import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';

export {
    init,
}

const POIs = [
    {
        name: 'dialogue-l',
        position: { x: -31, y: -7, z: 0 },
        color: 'white',
        sound: {
            name: 'dialogue-l',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
    {
        name: 'dialogue-r',
        position: { x: -29, y: -8, z: 0 },
        color: 'white',
        sound: {
            name: 'dialogue-r',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
    },
];

const sounds = [
    { name: 'dialogue-l', url: new URL('../../sound/DialogueBizarreL.wav', import.meta.url) },
    { name: 'dialogue-r', url: new URL('../../sound/DialogueBizarreR.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
